import {supabase} from'../api/supabaseClient.js';

const SCHEMA='screening-summary-v1';
const SCOPE='SCREENING_SUMMARY';
const clean=s=>String(s||'').trim().toUpperCase();
const n=v=>v==null||v===''||!Number.isFinite(Number(v))?null:Number(v);

function client(){if(!supabase)throw new Error('Supabase frontend environment is not configured.');return supabase;}

export function buildScreeningSummary(symbol,bundle={},researchState='REVIEW',savedAt=new Date().toISOString()){
 const ticker=clean(symbol);
 const facts=bundle?.companyFacts||{},alpha=bundle?.alphaCompany?.company||{},tenX=bundle?.tenXResearch||{},insider=bundle?.insiderEvidence||{},moat=bundle?.moatEvidence||{},dog=bundle?.dogEvidence||{},stock=bundle?.stockOpportunityEvidence||{},sheep=bundle?.sheepEvidence||{},fox=bundle?.foxEvidence||{},rocket=bundle?.rocketEvidence||{},mole=bundle?.moleEvidence||{},grass=bundle?.grasshopperEvidence||{},quality=bundle?.companyQualityEvidence||{},market=bundle?.market||{},coverage=bundle?.coverage||{};
 return{
  ticker,
  companyName:facts.companyName||alpha.name||ticker,
  researchState:String(researchState||'REVIEW').toUpperCase(),
  savedAt,
  marketStatus:market.status||'MISSING',
  price:n(market.price),
  marketAsOf:market.asOf||null,
  marketCapApprox:n(tenX.marketCapApprox),
  forwardRevenueGrowthPct:n(tenX.forwardRevenueGrowthPct),
  analystCount:n(tenX.analystCount),
  tenXState:tenX.state||'REVIEW',
  tenXStatus:tenX.status||'REVIEW',
  tenXScale:tenX.scale||'MISSING',
  tenXGrowth:tenX.growth||'MISSING',
  tenXSupportCount:n(tenX.supportCount)||0,
  insiderState:insider.state||'MISSING',
  insiderStatus:insider.status||'MISSING',
  insiderPurchases30:Array.isArray(insider.purchases30)?insider.purchases30.length:0,
  insiderUnique30:n(insider.uniquePurchaseInsiders30)||0,
  latestInsiderPurchase:insider.latestPurchaseDate||null,
  moatState:moat.state||'REVIEW',
  moatStatus:moat.status||'MISSING',
  moatEconomics:moat.economics||'MISSING',
  moatCustomerEvidence:moat.customerEvidence||'MISSING',
  moatEcosystemEvidence:moat.ecosystemEvidence||'MISSING',
  dogState:dog.state||'MISSING',
  dogStatus:dog.status||'MISSING',
  dogSupportiveSignals:n(dog.supportiveSignals)||0,
  dogCautionSignals:n(dog.cautionSignals)||0,
  dogDurability:dog.durability||'MISSING',
  dogTrend:dog.trend||'MISSING',
  stockOpportunityState:stock.state||'REVIEW',
  stockOpportunityStatus:stock.status||'REVIEW',
  stockOpportunitySupportCount:n(stock.supportCount)||0,
  stockOpportunityRiskCount:n(stock.riskCount)||0,
  stockOpportunitySupports:Array.isArray(stock.supports)?stock.supports.slice(0,8):[],
  stockOpportunityRisks:Array.isArray(stock.risks)?stock.risks.slice(0,8):[],
  sheepState:sheep.state||'MISSING',
  sheepStatus:sheep.status||'MISSING',
  sheepShortState:sheep.shortState||'MISSING',
  sheepOwnershipState:sheep.ownershipState||'MISSING',
  sheepShortFloatPct:n(sheep.shortFloatPct),
  sheepTop10HolderPct:n(sheep.top10HolderPct),
  sheepShortFreshness:sheep.shortFreshness||'MISSING',
  sheepOwnershipFreshness:sheep.ownershipFreshness||'MISSING',
  foxState:fox.state||'MISSING',
  foxStatus:fox.status||'MISSING',
  foxAnalystCount:n(fox.analystCount),
  foxSizeContext:fox.sizeContext||'MISSING',
  rocketState:rocket.state||'MISSING',
  rocketStatus:rocket.status||'MISSING',
  rocketIntensity:rocket.intensity||'MISSING',
  rocketPrice20dPct:n(rocket.price20dPct),
  rocketEps7dPct:n(rocket.epsRevision7dPct),
  rocketEps30dPct:n(rocket.epsRevision30dPct),
  moleState:mole.state||'MISSING',
  moleStatus:mole.status||'MISSING',
  moleFlagCount:n(mole.flagCount)||0,
  moleObservedDimensions:n(mole.observedDimensions)||0,
  moleFlagCodes:Array.isArray(mole.flags)?mole.flags.map(f=>f.code).filter(Boolean).slice(0,8):[],
  grasshopperState:grass.state||'MISSING',
  grasshopperStatus:grass.status||'MISSING',
  grasshopperEvidenceType:grass.evidenceType||'MISSING',
  grasshopperLiquidityBand:grass.liquidityBand||'MISSING',
  grasshopperTurnoverPct:n(grass.avgTurnoverPct20d),
  grasshopperPriceImpact5mPct:n(grass.priceImpact5mPct),
  qualityStatus:quality.status||'MISSING',
  coverageAvailable:n(coverage.availableCount)||0,
  coverageTotal:n(coverage.totalCount)||0
 };
}

export async function persistScreeningSummary(symbol,bundle,researchState='REVIEW',savedAt=new Date().toISOString()){
 const c=client(),ticker=clean(symbol);
 if(!/^[A-Z0-9.\-]{1,12}$/.test(ticker))throw new Error('VALID_SYMBOL_REQUIRED');
 const{data:userResult,error:userError}=await c.auth.getUser();
 if(userError)throw userError;
 const user=userResult?.user;if(!user)throw new Error('Authentication required.');
 const payload=buildScreeningSummary(ticker,bundle,researchState,savedAt);
 const record={user_id:user.id,storage_key:`screening_summary:${ticker}`,symbol:ticker,scope:SCOPE,schema_version:SCHEMA,saved_at:savedAt,payload,updated_at:savedAt};
 const{data,error}=await c.from('research_states').upsert(record,{onConflict:'user_id,storage_key'}).select('storage_key,symbol,scope,schema_version,saved_at,payload,updated_at').single();
 if(error)throw error;
 return data;
}

export async function loadScreeningSummaries(){
 const{data,error}=await client().from('research_states').select('storage_key,symbol,scope,schema_version,saved_at,payload,updated_at').eq('scope',SCOPE).order('saved_at',{ascending:false}).limit(250);
 if(error)throw error;
 return(data||[]).filter(r=>r.schema_version===SCHEMA&&r.payload&&typeof r.payload==='object');
}

const tenxRank={HIGH_10X_RESEARCH_PRIORITY:0,WATCH_10X_RESEARCH_PRIORITY:1,REVIEW:2,LOW_10X_FIT:3,SCALE_CONSTRAINED:4};
const researchRank={LIVE:0,VERIFIED:0,PARTIAL:1,REVIEW:2,MISSING:3};

export function deriveResearchShortlist(rows=[]){
 return(rows||[]).map(r=>({row:r,...r.payload,symbol:r.symbol||r.payload?.ticker||'',savedAt:r.saved_at||r.payload?.savedAt||null}))
  .sort((a,b)=>(tenxRank[a.tenXState]??9)-(tenxRank[b.tenXState]??9)
   ||(researchRank[a.researchState]??9)-(researchRank[b.researchState]??9)
   ||Number(b.insiderState==='CLUSTER_CODE_P')-Number(a.insiderState==='CLUSTER_CODE_P')
   ||String(b.savedAt||'').localeCompare(String(a.savedAt||'')));
}
